import React from 'react';
import styled from 'styled-components';
import QRCode from 'qrcode.react';
import palette from '../../lib/styles/palette';
import { LAUNCHER_APK, LAUNCHER_DOWNLOAD_PATH, resolveLauncherEnv } from '../../lib/def/launcherApp';

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 0;
`;

const Title = styled.div`
  font-size: 1.2rem;
  font-weight: 700;
  color: #222;
  margin-bottom: 10px;
`;

const EnvBadge = styled.span`
  display: inline-block;
  padding: 3px 12px;
  border-radius: 999px;
  font-size: .8rem;
  font-weight: 700;
  margin-bottom: 14px;
  color: ${props => props.live ? '#1e8449' : '#b7791f'};
  background: ${props => props.live ? '#e9f7ef' : '#fff6e0'};
  border: 1px solid ${props => props.live ? '#a9dfbf' : '#f6d48b'};
`;

const Desc = styled.div`
  font-size: .85rem;
  color: #888;
  margin-bottom: 24px;
  text-align: center;
  line-height: 1.6;
`;

const QRWrap = styled.div`
  padding: 20px;
  background: #f8f9fa;
  border-radius: 12px;
  margin-bottom: 16px;
`;

const LinkText = styled.div`
  font-size: .8rem;
  color: #aaa;
  margin-bottom: 24px;
  word-break: break-all;
  text-align: center;
  max-width: 280px;
`;

const BtnOpen = styled.button`
  width: 280px;
  padding: 10px 0;
  border-radius: 8px;
  font-size: .9rem;
  font-weight: 600;
  cursor: pointer;
  border: none;
  background: ${palette.webCyan[5]};
  color: #fff;
  transition: all 0.15s ease;

  &:hover {
    opacity: 0.85;
  }
`;

//--> QR 은 지금 접속한 관리자 사이트의 다운로드 페이지를 가리킨다. 그 페이지가 같은 빌드의
//    config.json 으로 테스트/라이브 APK 를 고르므로, 테스트 서버에선 테스트, 라이브 서버에선 라이브가 받아진다.
const AdminLauncherAppDownload = () => {
  const env = resolveLauncherEnv();
  const downloadURL = `${window.location.origin}${LAUNCHER_DOWNLOAD_PATH}`;

  return (
    <Wrap>
      <Title>제타트랙 런처 다운로드</Title>
      <EnvBadge live={env === 'live'}>{LAUNCHER_APK[env].label} 서버</EnvBadge>
      <Desc>
        QR코드를 스캔하면 제타트랙 런처 다운로드 페이지가 열립니다.<br />
        다운로드할 때 비밀번호를 입력해야 합니다.
      </Desc>
      <QRWrap>
        <QRCode value={downloadURL} size={180} />
      </QRWrap>
      <LinkText>{downloadURL}</LinkText>
      <BtnOpen onClick={() => window.open(downloadURL, '_blank')}>바로열기</BtnOpen>
    </Wrap>
  );
};

export default AdminLauncherAppDownload;
